/**
 * Refuerza la declaracion de receta del asistente de lentes (prescription-builder).
 * 1) Agrega un texto de declaracion sobre la casilla de confirmacion existente (paso de receta).
 * 2) Agrega una casilla obligatoria para quien elige "Agregar mi receta despues",
 *    que antes no tenia ninguna confirmacion.
 * Es independiente: no modifica prescription-builder.js ni el script del asistente.
 */
(function () {
  function initOne(root) {
    if (root.__rxAttestInit) return;
    root.__rxAttestInit = true;

    var q = function (ref) {
      return root.querySelector('[ref="' + ref + '"]');
    };
    var formId = root.dataset.productFormId || '';
    var noneInput = q('rxTypeNoneInput');
    var laterInput = q('entryMethodLaterInput');
    var laterNote = q('laterNote');

    // 1) Texto de declaracion junto a la casilla de confirmacion del paso 3.
    var confirmBox = root.querySelector('.prescription-builder__confirmation');
    if (confirmBox && !confirmBox.querySelector('.rx-attest-note')) {
      var note = document.createElement('p');
      note.className = 'prescription-builder__disclaimer rx-attest-note';
      note.innerHTML =
        'Al marcar esta casilla declaras que la receta es tuya o que estás autorizado a usarla, ' +
        'que está vigente y que copiaste los valores exactamente como aparecen en el documento. ' +
        'Fabricamos tus lentes con estos datos y no los verificamos con tu optometrista. ' +
        'Más información en nuestros <a href="/policies/terms-of-service" target="_blank" rel="noopener">Términos</a> ' +
        'y en la <a href="/policies/refund-policy" target="_blank" rel="noopener">Política de devoluciones</a>.';
      confirmBox.insertBefore(note, confirmBox.firstChild);
    }

    // 2) Casilla obligatoria para "Agregar mi receta despues".
    if (!laterNote || root.querySelector('.rx-later-confirm')) return;

    var wrap = document.createElement('div');
    wrap.className = 'prescription-builder__confirmation rx-later-confirm';
    wrap.hidden = true;

    var label = document.createElement('label');
    label.style.cssText = 'display:flex;gap:8px;align-items:flex-start;cursor:pointer;font-size:0.9em;';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.name = 'properties[Compromiso de enviar receta vigente]';
    input.value = 'Sí';
    input.disabled = true;
    input.style.cssText = 'margin-top:3px;flex:none;';
    if (formId) input.setAttribute('form', formId);

    var text = document.createElement('span');
    text.textContent =
      'Me comprometo a enviar una receta vigente y legible. Entiendo que mis lentes no se fabricarán ' +
      'hasta que la recibamos y la confirmemos, y que el plazo de entrega empieza en ese momento.';

    label.appendChild(input);
    label.appendChild(text);
    wrap.appendChild(label);
    laterNote.parentNode.insertBefore(wrap, laterNote.nextSibling);

    function sync() {
      var none = !!(noneInput && noneInput.checked);
      var later = !!(laterInput && laterInput.checked);
      var active = !none && later;
      wrap.hidden = !later;
      input.disabled = !active;
      input.required = active;
    }

    root.addEventListener('change', sync);
    sync();
    window.setTimeout(sync, 500);
  }

  function boot() {
    document.querySelectorAll('prescription-builder-component').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          boot();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
